import styled, { css } from 'styled-components';
import { colors } from '../../styles/colors';
import type { PoweredByDielSize } from '.';

export const PoweredByText = styled.span`
  color: ${colors.White};
`;

const LOGO_SIZE: Record<PoweredByDielSize, ReturnType<typeof css>> = {
  menu: css`
    width: 39px;
    height: 47px;
    margin-left: 2px;
    margin-bottom: 3px;
  `,
  login: css`
    width: 33px;
    height: auto;
    max-width: none;
  `,
};

/**
 * `&&` dobra a especificidade da classe para vencer regras genéricas de `img`
 * dos containers das telas de login (ex.: `Container img { width: 130px }`).
 */
export const PoweredByLogo = styled.img<{ $size: PoweredByDielSize }>`
  && {
    ${({ $size }) => LOGO_SIZE[$size]}
  }
`;
